<template>
    <div>
        <div class="head">
            <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
        </div>
        <div class="content">
            <el-table
                    :data="riskInfoList"
                    :header-cell-style="{ background: 'rgb(250,250,250)' }"
                    style="width: 100%">
                <el-table-column label="危险源" align="center" prop="dangersrc.dangersrcName" />
                <el-table-column label="安全风险" align="center" prop="riskInfo" />
                <el-table-column label="事故类型" align="center" prop="acciedntType" >
                    <template slot-scope="scope">
                        <el-link>{{handleAcciedntType(scope.row.acciedntType)}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="管控层级" align="center" prop="ctrlLevel" >
                    <template slot-scope="scope">
                        <el-link>{{handleCtrlType(scope.row.ctrlLevel)}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="危险因素" align="center" prop="dangeFactor" />
                <el-table-column label="风险等级" align="center" prop="riskLevel" >
                    <template slot-scope="scope">
                        <el-link>{{handleType(scope.row.riskLevel)}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="创建人" align="center" prop="creator"/>
                <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                        <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
                        <span style="margin: 0 5px;color: #e8e8e8">|</span>
                        <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 15px">
                <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
            </div>
        </div>

        <!-- 添加或修改安全风险信息管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item label="危险源" prop="dangersrcId">
                    <el-select v-model="form.dangersrcId" placeholder="请选择危险源" >
                        <el-option
                                v-for="dict in dangersrcList"
                                :key="dict.dangersrcId"
                                :label="dict.dangersrcName"
                                :value="dict.dangersrcId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安全风险" prop="riskInfo">
                    <el-input v-model="form.riskInfo" placeholder="请输入安全风险" />
                </el-form-item>
                <el-form-item label="事故类型" prop="acciedntType">
                    <el-select v-model="form.acciedntType" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in acciedntTypeArr"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="重点管控风险" prop="seriousResult">
                    <el-select v-model="form.seriousResult" style="width: 100%">
                        <el-option :value="1" label="是"/>
                        <el-option :value="0" label="否"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细位置" prop="riskpointLocaltion">
                    <el-input v-model="form.riskpointLocaltion" placeholder="请输入详细位置" />
                </el-form-item>
                <el-form-item label="伤亡/财产损失预测" prop="loseForecast">
                    <el-input v-model="form.loseForecast" type="textarea" placeholder="请输入内容" />
                </el-form-item>
                <el-form-item label="管控层级" prop="ctrlLevel">
                    <el-select v-model="form.ctrlLevel" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in ctrlLevelArr"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="危险因素" prop="dangeFactor">
                    <el-input v-model="form.dangeFactor" type="textarea" placeholder="请输入内容" />
                </el-form-item>
                <el-form-item label="风险等级" prop="riskLevel">
                    <el-select v-model="form.riskLevel" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in riskLevelArr"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="应急处置主要措施" prop="emerMeasure">
                    <el-input v-model="form.emerMeasure" type="textarea" placeholder="请输入内容" />
                </el-form-item>
                <el-form-item label="创建人" prop="creator">
                    <el-input v-model="form.creator" placeholder="请输入创建人"/>
                </el-form-item>
                <el-form-item label="数据对接省厅" prop="isTest">
                    <el-select v-model="form.isTest" style="width: 100%">
                        <el-option :value="1" label="否"/>
                        <el-option :value="0" label="是"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import { listRiskInfo,getDangersrcList, getRiskInfo, delRiskInfo, addRiskInfo, updateRiskInfo } from "@/api/doublePrevention/riskInfo";
    import { listDangersrc } from "@/api/doublePrevention/dangersrc";
    export default {
        name: 'ProcessRawMaterials',
        data() {
            return {
                // searchContent: '',
                riskInfoList: [],
                dangersrcList: [],
                total: 0,
                curPage: 1,
                pageSize: 10,
                open: false,
                form: {},
                rules: {},
                title: null,
                riskLevelArr: [
                    {
                        label: "重大风险",
                        value: "E4301"
                    },
                    {
                        label: "较大风险",
                        value: "E4302"
                    },
                    {
                        label: "一般风险",
                        value: "E4303"
                    },
                    {
                        label: "低风险",
                        value: "E4304"
                    }
                ],
                ctrlLevelArr: [
                    {
                        label: "集团",
                        value: "H9301"
                    },
                    {
                        label: "公司",
                        value: "H9302"
                    },
                    {
                        label: "部门",
                        value: "H9303"
                    },
                    {
                        label: "班组",
                        value: "H9304"
                    },
                    {
                        label: "岗位",
                        value: "H9305"
                    }
                ],
                acciedntTypeArr: [
                    {label: "物体打击", value: "E9201"},
                    {label: "车辆伤害", value: "E9202"},
                    {label: "机械伤害", value: "E9203"},
                    {label: "起重伤害", value: "E9204"},
                    {label: "触电", value: "E9205"},
                    {label: "淹溺", value: "E9206"},
                    {label: "灼烫", value: "E9207"},
                    {label: "火灾", value: "E9208"},
                    {label: "高处坠落", value: "E9209"},
                    {label: "坍塌", value: "E9210"},
                    {label: "冒顶片帮", value: "E9211"},
                    {label: "透水", value: "E9212"},
                    {label: "爆破", value: "E9213"},
                    {label: "火药爆炸", value: "E9214"},
                    {label: "瓦斯爆炸", value: "E9215"},
                    {label: "锅炉爆炸", value: "E9216"},
                    {label: "容器爆炸", value: "E9217"},
                    {label: "其它爆炸", value: "E9218"},
                    {label: "中毒和窒息", value: "E9219"},
                    {label: "其他伤害", value: "E9220"},
                    {label: "消防火灾", value: "E9221"},
                    {label: "道路交通", value: "E9222"},
                    {label: "水上交通", value: "E9223"},
                    {label: "铁路路外", value: "E9224"},
                    {label: "航空", value: "E9225"},
                    {label: "锅炉容器", value: "E9226"},
                    {label: "其他道路", value: "E9227"},
                    {label: "其他水上", value: "E9228"},
                    {label: "铁路路内", value: "E9229"},
                    {label: "其他", value: "E9230"},
                    {label: "渔业", value: "E9231"},
                    {label: "其它", value: "E9232"},
                ]
            }
        },
        created() {
            this.getRiskInfoList();
            this.getDangersrcList();
        },
        methods: {
            getRiskInfoList() {
                listRiskInfo({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
                    this.riskInfoList = res.body.data
                    this.total = res.body.cum
                })
            },
            getDangersrcList() {
              listDangersrc({limit:100, curPage: 1, type: 0, isPage: 1}).then(res => {
                console.log(res)
                    this.dangersrcList = res.body.data
                })
            },
            pageChange(val) {
                this.curPage = val;
                this.getRiskInfoList();
            },
            handleType(type){
                let list = this.riskLevelArr.filter(item =>item.value === type)
                return list[0].label
            },
            handleAcciedntType(type){
                let list = this.acciedntTypeArr.filter(item =>item.value === type)
                return list[0].label
            },
            handleCtrlType(type){
                let list = this.ctrlLevelArr.filter(item =>item.value === type)
                return list[0].label
            },
            addBtn() {
                this.reset()
                this.open = true
                this.title = '添加安全风险信息'
            },
            editBtn(row) {
                this.reset()
                const riskId = row.riskId
                getRiskInfo(riskId).then(response => {
                    this.form = response.body.data
                    this.open = true
                    this.title = '修改安全风险信息'
                })
            },
            deleteBtn(row) {
                delRiskInfo(row.riskId).then(res => {
                    this.$message.success('删除成功')
                    this.getRiskInfoList()
                })
            },
            // 取消按钮
            cancel() {
                this.open = false
                this.reset()
            },
            // 表单重置
            reset() {
                this.form = {
                    pageNum: 1,
                    pageSize: 10,
                    enterpriseId: null,
                    dangersrcId: null,
                    riskInfo: null,
                    acciedntType: null,
                    seriousResult: null,
                    riskpointLocaltion: null,
                    loseForecast: null,
                    ctrlLevel: null,
                    dangeFactor: null,
                    emerMeasure: null,
                    riskLevel: null,
                    companyCode: null,
                    createTime: null,
                    creator: null,
                    recordStatus: null,
                    isTest: null,
                    dangersrc:null
                }
            },
            /** 提交按钮 */
            submitForm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        if (this.form.riskId != null) {
                            updateRiskInfo(this.form).then(response => {
                                this.open = false
                                this.getRiskInfoList()
                            })
                        } else {
                            addRiskInfo(this.form).then(response => {
                                this.open = false
                                this.getRiskInfoList()
                            })
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .head {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 280px);
    }
    .btn {
        cursor: pointer;
    }
</style>
